import { getWeek } from 'date-fns';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StoreOpeningHours } from '../../../global-state/types';
import { useStoreOpeningHours, useUser } from '../../../hooks';
import { OpeningHours } from '../../../pages/home/common/openingHours/OpeningHours';
import { Typography } from '../../../stories/atoms';
import { ColumnFlexContainer } from '../../../stories/atoms/containerV2/ContainerV2';
import { Animation, Animations } from '../../../stories/molecules';
import { homeTranslations } from '../../../translations';

export type StoreOpeningHoursWidgetProps = {
  isError?: boolean;
};

export const StoreOpeningHoursWidget: FC<StoreOpeningHoursWidgetProps> = ({ isError }) => {
  const [isOpeningHours, setIsOpeningHours] = useState<StoreOpeningHours[]>();
  const { getWeeklyOpeningHours } = useStoreOpeningHours();

  const { t } = useTranslation();

  const numOfWeek = getWeek(new Date());

  const {
    get: { currentStoreId, stores },
  } = useUser();

  useEffect(() => {
    const storeData = stores.find((store) => store.storeId === currentStoreId);

    if (storeData) {
      const weekDataArray = getWeeklyOpeningHours(storeData);
      setIsOpeningHours(weekDataArray);
    }
  }, []);

  return (
    <ColumnFlexContainer
      data-testid="opening-hours-widget"
      gap={[4]}
      borderRadius={[4]}
      padding={[4]}
      margin={[0, 5]}
      shadow
    >
      {isError && (
        <Animation
          title=""
          animation={Animations.SAD}
          size="small"
          errorText={t(
            homeTranslations.slider.storeOpeningHoursError.key,
            homeTranslations.slider.storeOpeningHoursError.defaultValue,
          )}
        />
      )}
      {!isError && (
        <>
          <Typography type="button">
            {t(
              homeTranslations.slider.storeOpeningHours.key,
              homeTranslations.slider.storeOpeningHours.defaultValue,
            )}
            , W {numOfWeek}
          </Typography>
          {isOpeningHours && <OpeningHours openingHours={isOpeningHours} />}
        </>
      )}
    </ColumnFlexContainer>
  );
};
